<form #formRef="ngForm" class="details-screen">
	<bb-page-header [backOnMobile]="['/library/mediaclips']" [icon]="'pencil'"
		[title]="('CUSTOM_FIELD' | translate) + ': ' + customField.label">
		<ul class="tabs">
			<li>
				<a class="active">
					<i class="fa fa-pencil"></i> {{ 'CONFIGURATION' | translate }}
				</a>
			</li>
		</ul>
		<bb-status *ngIf="customField" [(ngModel)]="customField.public" name="public" [valueOn]="true"
			[valueOff]="false" [labelOn]="'PUBLIC' | translate" [labelOff]="'PRIVATE' | translate"></bb-status>
	</bb-page-header>

	<div class="body-column">

		<bb-form-element [form]="form" label="{{'LABEL' | translate}}">
			<input type="text" required [(ngModel)]="customField.label" name="label" (ngModelChange)="updateCode()" />
		</bb-form-element>

		<bb-form-element [form]="form" label="{{'CODE' | translate}}">
			<input type="text" required [(ngModel)]="customField.name" name="name"
				(input)="onCodeInput($event)"
				(ngModelChange)="showCodeChangeWarning()" />
			<span class="message error" *ngIf="!uniqueCode">{{ 'CODE_MUST_BE_UNIQUE' | translate }}</span>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'PUBLIC' | translate"
			[helpMessage]="'HELP.CUSTOM_FIELD_PUBLIC' | translate"
		>
			<bb-check [(ngModel)]="customField.public" name="public"></bb-check>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'INCLUDED_IN_STATS' | translate" [hasPublicationFieldOrPermission]="'includeInStats'"
			[disabled]="!(customField.public && ['string', 'boolean', 'int', 'float'].includes(this.customField.type))"
			[helpMessage]="'HELP.CUSTOM_FIELD_INCLUDED_IN_STATS' | translate"
		>
			<bb-check [(ngModel)]="customField.includeInStats" name="includeInStats"></bb-check>
		</bb-form-element>


		<bb-form-element [form]="form" [label]="'MANDATORY' | translate">
			<bb-check [(ngModel)]="customField.priority" name="priority" [trueValue]="'mandatory'" [falseValue]="null"></bb-check>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'VISIBLE' | translate"
			[helpMessage]="'HELP.CUSTOM_FIELD_VISIBLE' | translate">
			<bb-check [(ngModel)]="customField.visible" name="visible"></bb-check>
		</bb-form-element>

		<bb-form-element [form]="form" [label]="'TYPE' | translate">
			<bb-button-toggle [options]="customFieldTypes" [(ngModel)]="customField.itype"
				(ngModelChange)="fieldTypeChanged($event)" name="itype"></bb-button-toggle>
		</bb-form-element>

		<ng-container *ngIf="customField.itype === 'list'">
			<bb-form-element [form]="form" [label]="'ALLOW_MULTISELECT' | translate">
				<bb-check [(ngModel)]="customField.type" name="type" [trueValue]="'multistring'" [falseValue]="'string'"></bb-check>
			</bb-form-element>

			<bb-form-element [form]="form" [label]="'EXTENDABLE' | translate">
				<bb-check [(ngModel)]="customField.extendable" name="extendable"></bb-check>
			</bb-form-element>

			<ng-container *ngIf="!customField.extendable">
				<bb-form-element class="field-options" [form]="form" [label]="'OPTIONS' | translate">
					<bb-label-code-list [(ngModel)]="customField.options" name="options"></bb-label-code-list>
				</bb-form-element>
			</ng-container>
		</ng-container>
		<div *ngIf="customField.itype === 'relation' || customField.itype === 'relationlist'">
			<bb-form-element [form]="form" [label]="'ALLOW_MULTIPLE_RELATIONS' | translate">
				<bb-check [(ngModel)]="customField.type" name="multipleRelations"
					[trueValue]="'relationlist'"
					[falseValue]="'relation'"
					(onChanged)="multipleRelationsChanged($event)"></bb-check>
			</bb-form-element>

			<bb-form-element [form]="form" [label]="'CONTENT_TYPE' | translate" [hasPublicationField]="'contenttype'">
				<bb-select [(ngModel)]="customField.contenttype" [options]="contentOptions" name="contenttype"></bb-select>
			</bb-form-element>

			<bb-form-element [form]="form" [label]="'USETYPES' | translate">
				<input type="hidden" [(ngModel)]="customField.contentusetypes" name="contentusetypes" />
				<div class="multi-check">
					<label class="check-pair" *ngFor="let val of contentUseTypeOptions; let i = index">
						<bb-check [checked]="hasUseType(val.value)" (onChanged)="useTypeChange(val.value, $event, i)">
						</bb-check>
						<span>
							{{ val.label | translate }}
						</span>
					</label>
				</div>
			</bb-form-element>

			<bb-form-element [form]="form" [label]="'MEDIATYPES' | translate">
				<input type="hidden" [(ngModel)]="customField.contentsubtypes" name="contentsubtypes" />
				<div class="multi-check">
					<label class="check-pair" *ngFor="let val of contentSubTypeOptions; let i = index">
						<bb-check [checked]="hasMediaType(val.value)" (onChanged)="mediaTypeChange(val.value, $event, i)">
						</bb-check>
						<span>
							{{ val.label | translate }}
						</span>
					</label>
				</div>
			</bb-form-element>

		</div>
		<div *ngIf="customField.type === 'int' || customField.type === 'float'">
			<bb-form-element [form]="form" [label]="'CUSTOM_FIELD_FLOAT_CHECKBOX' | translate"
				[helpMessage]="'HELP.CUSTOM_FIELD_FLOAT_CHECKBOX' | translate">
				<bb-check [(ngModel)]="customField.allowDecimals" name="allowDecimals"></bb-check>
			</bb-form-element>
		</div>

	</div>
</form>
<bb-actions-bar (onSave)="save()" (onCancel)="cancel()" [form]="form"></bb-actions-bar>
